<template>
    <section class="relative overflow-hidden border-b border-green-600 bg-gray-200 dark:bg-gray-800">
        <PagesPageHeader
            :breadcrumbs="breadcrumbs"
            title="Plantation Ownership"
            description="At least fifteen species of Aquilaria are known to produce the much sought-after agarwood."
            icon="i-lucide-trees"
            iconColor="green"
            color="blue"
            :image="true"
            src="/assets/images/sliders/slider-03.webp" />
    </section>

    <ULandingSection
        title="Agarwood or Gaharu"
        description="Aquilaria can grow on a wide range of soils, including poor sandy soil."
        :features="[
            // {
            //     name: 'Sowing the Seedlings',
            //     description:
            //         'Agarwood or Gaharu as it is known in many Asian countries is a resinous heartwood that occurs in trees belonging to the genus Aquilaria. The Aquilaria tree is a fast-growing, subtropical forest tree, with a population range stretching from South Asia’s Himalayan foothills, throughout Southeast Asia, and into the rainforests of Papua New Guinea. It grows at elevations from a few meters above sea level to about 1000 meters, with approx. 500 meters being most ideal.',
            //     icon: 'i-lucide-trees'
            // },
            {
                name: 'Agarwood Production',
                description:
                    'Aquilaria can grow on a wide range of soils, including poor sandy soil. Seedlings require a great deal of shade and water but will grow rapidly, producing flowers and seeds as early as four years old. At least fifteen species of Aquilaria are known to produce the much sought-after agarwood. In South Asia, particularly India, Aquilaria achalloga is found. Aquilaria malaccensis is mostly known in Thailand Malaysia and Indonesia, while Aquilaria crassna grows primarily in Indochina. A number of others are also known, such as Aquilaria grandfolia, Aquilaria chinesis etc., though these are relatively minor species for agarwood production.',
                icon: 'i-lucide-trees'
            }
        ]"
        align="right"
        :ui="{
            title: 'text-3xl font-bold text-green-600 sm:text-4xl lg:text-4xl'
        }">
        <NuxtImg
            format="webp"
            width="840"
            height="473"
            class="w-[100%] rounded-xl"
            src="/assets/images/gallery/gallery-18.webp"
            :alt="config.public.company.name" />
    </ULandingSection>

    <UDivider
        icon="i-ph-plant"
        :ui="{
            icon: {
                base: 'flex-shrink-0 w-10 h-10 text-green-600'
            }
        }" />

    <ULandingSection
        title="Agarwood Usage"
        description="Agarwood, the “Wood of the Gods” has been traded and highly coveted for thousands of years."
        :features="[
            // {
            //     name: 'Wood of the Gods',
            //     description:
            //         'The resinous wood is used as incense, for medicinal purposes, and pure resin in distilled form is used as an essential oil as well as a perfume component. Outside its native countries, it is most widely known in the Middle East, China, Taiwan, and Japan.',
            //     icon: 'i-lucide-trees'
            // },
            {
                name: 'Traditional and Religious Ceremonies',
                description:
                    'A strong connection exists between uses in religion and curative properties. Elaborate traditional and religious ceremonies using Agarwood are known around the world. Faith healers in the Middle East use it at curative ceremonies, Japanese pilgrims donate flowers and Agarwood oil to Shinto-Buddhist temples, and Vietnamese religious groups are obliged to bring Agarwood to ceremonies at their temples in Mekong Delta communities.',
                icon: 'i-lucide-trees'
            }
        ]"
        align="left"
        :ui="{
            title: 'text-3xl font-bold text-green-600 sm:text-4xl lg:text-4xl'
        }">
        <NuxtImg
            format="webp"
            width="840"
            height="473"
            class="w-[100%] rounded-xl"
            src="/assets/images/gallery/gallery-19.webp"
            :alt="config.public.company.name" />
    </ULandingSection>

    <PagesCalloutsPlantationOwnership />
</template>

<script setup>
    definePageMeta({
        layout: 'default'
    })

    const config = useRuntimeConfig()
    const router = useRouter()

    useHead({
        title: `${config.public.company.name} | Plantation Ownership`,
        meta: [
            {
                name: 'description',
                content: 'At least fifteen species of Aquilaria are known to produce the much sought-after agarwood.'
            },
            { name: 'robots', content: 'index, follow' }
        ],
        link: [{ rel: 'canonical', href: `${config.public.base.url + router.currentRoute.value.path}` }]
    })

    const breadcrumbs = [{ label: 'Home', to: '/' }, { label: 'Opportunities', to: '/opportunities' }, { label: 'Plantation Ownership' }]
</script>
